import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["intervals-or-steady-running"]!;

export function Body() {
  return (
    <>
      <p>
        Do you need intervals to get fitter, or is steady running enough? A meta-analysis of 28
        studies compared the two.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers pooled controlled studies of healthy adults aged 18 to 45 who trained for at
        least two weeks, either with high-intensity intervals or with steady endurance training.
        In total, 723 people took part. Maximal oxygen uptake was measured before and after.
      </p>

      <h2>What they found</h2>
      <p>
        Both types of training gave large improvements compared with not training: 4.9 ml/kg/min
        with steady training and 5.5 ml/kg/min with intervals.
      </p>
      <p>
        Intervals gave a slightly larger improvement than steady training, about 1.2 ml/kg/min
        more. People who started with lower fitness and programmes that lasted longer tended to
        improve more with both types.
      </p>

      <h2>What it means for you</h2>
      <p>
        Both work. Steady running builds a lot of fitness on its own, and intervals add a little
        more. For most runners, the best answer is both: mostly easy running, with some interval
        sessions.
      </p>
      <p>
        Intervals are hard, and more of them is not always better. They work best when you are
        fresh enough to do them well.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The studies measured maximal oxygen uptake, not race times. Most participants were young
        and not very fit when they started, and the studies were short. Trained runners usually
        improve less.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training combines easy running with harder sessions such as intervals and tempo
        runs. How many hard sessions you get depends on your goal, the time you have and how you
        recover.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Milanović, Sporiš & Weston (2015), Effectiveness of high-intensity interval training
          (HIT) and continuous endurance training for VO2max improvements: a systematic review
          and meta-analysis of controlled trials.{" "}
          <a href="https://doi.org/10.1007/s40279-015-0365-0">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
